import { type Static, Type } from "@sinclair/typebox";
import { AvatarSchema } from "../avatar/schema.ts";
import { IdSchema } from "./requests.ts";
import type { Category, Post, Thread } from "./dto.ts";
import type { ChatMessage } from "./chat.ts";

export const ClientMessageSchema = Type.Union([
  Type.Object({ type: Type.Literal("subscribe.thread"), threadId: IdSchema }),
  Type.Object({ type: Type.Literal("unsubscribe.thread"), threadId: IdSchema }),
  Type.Object({ type: Type.Literal("ping") }),
]);

export type ClientMessage = Static<typeof ClientMessageSchema>;

export const PresenceUserSchema = Type.Object({
  id: IdSchema,
  handle: Type.String(),
  name: Type.String(),
  avatar: AvatarSchema,
  isBot: Type.Boolean(),
});

export type PresenceUser = Static<typeof PresenceUserSchema>;

/**
 * スレッド一覧に効く更新。開いているスレッドに関係なく全員に配る。
 * 一覧をキャッシュしたまま最新に保つためのもので、本文は載せない。
 */
export type ThreadBump = {
  threadId: number;
  categoryId: number;
  postCount: number;
  lastPostAt: string;
};

export type ServerEvent =
  | { type: "hello"; userId: number | null; online: PresenceUser[] }
  | { type: "presence"; online: PresenceUser[] }
  | { type: "thread.post"; threadId: number; post: Post }
  /** 新しいスレッドが立った。一覧に足す。 */
  | { type: "thread.created"; thread: Thread }
  /** 既存スレッドにレスが付いた。件数と並び順が変わる。 */
  | { type: "thread.bumped"; bump: ThreadBump }
  /**
   * スレッドの表示 / 非表示が変わった。一覧から出し入れする。
   * 非表示のものは admin にしか届かないので、そうでなければ一覧から外すだけでよい。
   */
  | { type: "thread.visibility"; thread: Thread }
  | { type: "category.changed"; category: Category }
  | { type: "chat.message"; message: ChatMessage }
  | { type: "pong" };
